import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Heading, SummaryTable } from '@chargify/custom-ui-components';
import { Currency } from '@chargify/formatters';
import { useDeviceInfo } from '@chargify/device-provider';
import { AllocationDetails } from '../../../../machines/addOnsConfiguration/types';
import { mapAllocationsToTable } from '../../utils';

export type AllocationsTableProps = {
  heading: string;
  componentsAllocations: AllocationDetails[];
  currency: Currency;
};

const AllocationsTable = ({
  heading,
  componentsAllocations,
  currency,
}: AllocationsTableProps) => {
  const { t, i18n } = useTranslation(['subscriptions-manager']);
  const { device } = useDeviceInfo();

  return (
    <Box marginBottom={5} paddingLeft={5} paddingRight={5}>
      <Box marginBottom={2}>
        <Heading variant="h5">{heading}</Heading>
      </Box>
      <SummaryTable
        rows={mapAllocationsToTable({
          componentsAllocations,
          t,
          language: i18n.language,
          currency,
        })}
        columnSpans={device === 'mobile' ? [24, 16, 8] : [8, 8, 8]}
      />
    </Box>
  );
};

export default AllocationsTable;
